import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";

const MainNav = () => {
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className="position-absolute ps-5 bg-none"
    >
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link href="#home">Home</Nav.Link>
          <Nav.Link href="#about">About</Nav.Link>
          <Nav.Link href="#portfolio">portfolio</Nav.Link>
          <Nav.Link href="#contact">contact</Nav.Link>
          <Nav.Link
            href="https://docs.google.com/document/d/1yokf4gIxIl8Y4NbMSOEqiieVyRREk2Q1/edit?usp=sharing&ouid=114749735677642710070&rtpof=true&sd=true"
            download="Cheyenne Threadgill Resume"
          >
            Resume
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default MainNav;
